import React from 'react';
import { Grid } from '@mui/material';

import { CurrencyTextField, DateField, ModuleSearchField, SimpleTextField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function ErpQuotationsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* CODE */}
				<SimpleTextField
					name="quot_erp_id"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_CODE')}
					value={props.model.quot_erp_id}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* ORDER DATE */}
				<DateField
					name="quot_d_order"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_DATE_ORDER')}
					value={props.model.quot_d_order}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* REQUESTED DELIVERY DATE */}
				<DateField
					name="quot_d_delivery_requested"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_DATE_DATE_REQDELIVERY')}
					value={props.model.quot_d_delivery_requested}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* PROMISED DELIVERY DATE */}
				<DateField
					name="quot_d_delivery_promised"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_DATE_DATE_PROMDELIVERY')}
					value={props.model.quot_d_delivery_promised}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* CUSTOMER */}
				<ModuleSearchField
					name="quot_comp_uid"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_COMPANY')}
					module="companies"
					uid={props.model.quot_comp_uid}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BILLING COMPANY */}
				<ModuleSearchField
					name="quot_bill_comp_uid"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_BILL_COMPANY')}
					module="companies"
					uid={props.model.quot_bill_comp_uid}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* SALESPERSON */}
				{props.model.quot_user_salesperson_uid ? (
					<ModuleSearchField
						name="quot_user_salesperson_uid"
						label={t('DETAILS_ERP_QUOTATIONS_FIELD_SALESPERSON')}
						module="users"
						uid={props.model.quot_user_salesperson_uid}
						isEdit={false}
						sendChange={props.sendChange}
					/>
				) : (
					<SimpleTextField
						name="quot_user_salesperson_title"
						label={t('DETAILS_ERP_QUOTATIONS_FIELD_SALESPERSON')}
						value={props.model.quot_user_salesperson_title}
						isEdit={false}
						sendChange={props.sendChange}
					/>
				)}
			</Grid>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* TOT TAX EXCLUDED */}
				<CurrencyTextField
					name="quot_tot_value_tax_excl"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_TOT_TAX_EXCL')}
					value={props.model.quot_tot_value_tax_excl}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* TOT TAX INCLUDED */}
				<CurrencyTextField
					name="quot_tot_value_tax_incl"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_TOT_TAX_INCL')}
					value={props.model.quot_tot_value_tax_incl}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
		</>
	);
}
